/**
 * PDP - Recently viewed products carousel (dynamic, bottom of page).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tcn_pdp_recently_viewed';
  var COOKIE_KEY = 'brilliant_products_recently';
  var STORE_CAP = 20;

  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function shopifyImageUrl(base, width) {
    if (!base) return '';
    var url = base.indexOf('//') === 0 ? 'https:' + base : base;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width;
  }

  function readCookieHandles() {
    if (!window.jQuery || !jQuery.cookie) return [];
    var cookie = jQuery.cookie(COOKIE_KEY);
    if (!cookie) return [];
    return cookie.split('|').filter(Boolean);
  }

  function getHandles() {
    var handles = [];
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored) handles = JSON.parse(stored);
    } catch (e) {
      handles = [];
    }
    if (!Array.isArray(handles) || !handles.length) {
      handles = readCookieHandles();
    }
    return handles.filter(Boolean);
  }

  function saveHandles(handles) {
    var trimmed = handles.filter(Boolean).slice(0, STORE_CAP);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    } catch (e) {}
    if (window.jQuery && jQuery.cookie) {
      if (trimmed.length) {
        jQuery.cookie(COOKIE_KEY, trimmed.join('|'), { path: '/', expires: 30 });
      } else {
        jQuery.removeCookie(COOKIE_KEY, { path: '/' });
      }
    }
    return trimmed;
  }

  function removeHandle(handle) {
    if (!handle) return;
    saveHandles(
      getHandles().filter(function (h) {
        return h !== handle;
      })
    );
  }

  function recordView(handle) {
    if (!handle) return;
    var handles = getHandles().filter(function (h) {
      return h !== handle;
    });
    handles.unshift(handle);
    saveHandles(handles);
  }

  function fetchProduct(handle) {
    return fetch(shopRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('not found');
      return res.json();
    });
  }

  function buildSameCollectionSlide(product, blockId) {
    var titleId = 'tcn-pdp-rv-title-' + blockId + '-' + product.id;
    var img = product.featured_image;
    var imgHtml = '';

    if (img) {
      imgHtml =
        '<img src="' +
        shopifyImageUrl(img, 480) +
        '" srcset="' +
        shopifyImageUrl(img, 320) +
        ' 320w, ' +
        shopifyImageUrl(img, 480) +
        ' 480w, ' +
        shopifyImageUrl(img, 640) +
        ' 640w" sizes="460px" alt="' +
        escapeHtml(product.title) +
        '" class="tcn-pdp-same-collection__img" width="480" height="480" decoding="async" loading="lazy">';
    }

    return (
      '<article class="tcn-pdp-same-collection__slide">' +
      '<a href="' +
      product.url +
      '" class="tcn-pdp-same-collection__card" aria-labelledby="' +
      titleId +
      '">' +
      '<div class="tcn-pdp-same-collection__media">' +
      imgHtml +
      '<div class="tcn-pdp-same-collection__meta">' +
      '<h3 class="tcn-pdp-same-collection__title" id="' +
      titleId +
      '">' +
      escapeHtml(product.title) +
      '</h3>' +
      '<span class="tcn-pdp-same-collection__view-link">View work</span>' +
      '</div></div></a></article>'
    );
  }

  function buildDynamicCard(product) {
    var img = product.featured_image;
    var bgStyle = img ? ' style="background-image: url(' + shopifyImageUrl(img, 500) + ');"' : '';
    var hoverImg = '';

    if (product.images && product.images.length > 1) {
      var altImg = product.images[product.images.length - 1];
      hoverImg =
        '<img src="' +
        shopifyImageUrl(altImg, 500) +
        '" alt="' +
        escapeHtml(product.title) +
        '" class="tcn-hover-image" loading="lazy" width="500" height="500">';
    }

    return (
      '<div class="tcn-carousel-card">' +
      '<a href="' +
      product.url +
      '" class="tcn-carousel-image-wrapper" aria-label="View ' +
      escapeHtml(product.title) +
      '">' +
      '<div class="tcn-carousel-image"' +
      bgStyle +
      '>' +
      hoverImg +
      '</div></a>' +
      '<div class="tcn-carousel-info">' +
      '<a href="' +
      product.url +
      '" class="tcn-carousel-title-link">' +
      escapeHtml(product.title) +
      '</a>' +
      '<div class="tcn-carousel-price">from ' +
      escapeHtml(product.price) +
      '</div>' +
      '</div></div>'
    );
  }

  function initDesktopCarousel(root) {
    if (!root) return;
    if (window.TcnPdpSameCollection && typeof window.TcnPdpSameCollection.init === 'function') {
      window.TcnPdpSameCollection.init(root);
      return;
    }
    window.setTimeout(function () {
      if (window.TcnPdpSameCollection && typeof window.TcnPdpSameCollection.init === 'function') {
        window.TcnPdpSameCollection.init(root);
      }
    }, 120);
  }

  function initMobileCarousel(root) {
    if (!root) return;
    if (window.TcnDynamicCarousel && typeof window.TcnDynamicCarousel.init === 'function') {
      window.TcnDynamicCarousel.init(root);
      return;
    }
    window.setTimeout(function () {
      if (window.TcnDynamicCarousel && typeof window.TcnDynamicCarousel.init === 'function') {
        window.TcnDynamicCarousel.init(root);
      }
    }, 120);
  }

  function isDesignMode() {
    return !!(window.Shopify && Shopify.designMode);
  }

  function hideMount(mount) {
    if (!mount || isDesignMode()) return;
    mount.hidden = true;
    mount.setAttribute('aria-hidden', 'true');
  }

  function showMount(mount) {
    if (!mount) return;
    mount.hidden = false;
    mount.removeAttribute('aria-hidden');
  }

  function populateCarousel(root) {
    var mount =
      root.closest('[data-tcn-recently-viewed-mount]') ||
      root.closest('#tcn-pdp-recently-viewed-mount') ||
      root.parentElement;
    var desktopRoot =
      mount && mount.querySelector('[data-tcn-pdp-recently-viewed-carousel]:not([data-tcn-pdp-recently-viewed-carousel-dynamic])');
    var mobileRoot =
      mount && mount.querySelector('[data-tcn-pdp-recently-viewed-carousel-dynamic]');
    var desktopTrack = desktopRoot ? desktopRoot.querySelector('.tcn-pdp-same-collection__track') : null;
    var mobileTrack = mobileRoot ? mobileRoot.querySelector('.tcn-carousel-track') : null;

    if (!desktopTrack && !mobileTrack) {
      hideMount(mount);
      return;
    }

    var currentHandle =
      (desktopRoot && desktopRoot.getAttribute('data-current-handle')) ||
      (mobileRoot && mobileRoot.getAttribute('data-current-handle')) ||
      '';
    var limit =
      parseInt(
        (desktopRoot && desktopRoot.getAttribute('data-limit')) ||
          (mobileRoot && mobileRoot.getAttribute('data-limit')),
        10
      ) || 8;
    var blockId =
      (desktopRoot && desktopRoot.getAttribute('data-tcn-pdp-recently-viewed-carousel')) || 'recent';

    var handles = getHandles().filter(function (handle) {
      return handle && handle !== currentHandle;
    });

    if (!handles.length) {
      hideMount(mount);
      return;
    }

    handles = handles.slice(0, limit);

    Promise.all(
      handles.map(function (handle) {
        return fetchProduct(handle)
          .then(function (product) {
            return { handle: handle, product: product };
          })
          .catch(function () {
            removeHandle(handle);
            return { handle: handle, product: null };
          });
      })
    ).then(function (results) {
      var valid = results
        .filter(function (entry) {
          return entry.product;
        })
        .map(function (entry) {
          return entry.product;
        });

      if (!valid.length) {
        hideMount(mount);
        return;
      }

      var validHandles = results
        .filter(function (entry) {
          return entry.product;
        })
        .map(function (entry) {
          return entry.handle;
        });
      saveHandles(validHandles);

      if (desktopTrack) {
        desktopTrack.innerHTML = valid
          .map(function (product) {
            return buildSameCollectionSlide(product, blockId);
          })
          .join('');
        if (desktopRoot) desktopRoot.setAttribute('data-slide-count', String(valid.length));
      }

      if (mobileTrack) {
        mobileTrack.innerHTML = valid
          .map(function (product) {
            return buildDynamicCard(product);
          })
          .join('');
      }

      showMount(mount);
      if (desktopRoot) initDesktopCarousel(desktopRoot);
      if (mobileRoot) initMobileCarousel(mobileRoot);
    });
  }

  function boot() {
    var config = window.TCN_PDP_RECENTLY_VIEWED || {};
    var mounts = document.querySelectorAll('[data-tcn-recently-viewed-mount]');

    if (!mounts.length) {
      if (config.currentHandle) recordView(config.currentHandle);
      return;
    }

    mounts.forEach(function (mount) {
      var desktopRoot = mount.querySelector(
        '[data-tcn-pdp-recently-viewed-carousel]:not([data-tcn-pdp-recently-viewed-carousel-dynamic])'
      );
      if (desktopRoot) populateCarousel(desktopRoot);
    });

    if (config.currentHandle) {
      recordView(config.currentHandle);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
